import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, BodyContainer } from '../StyledComponents/StyledComponents';
import Button from '../Utility/Button';
import { HomeHeroContainer } from './Style';

const HomeHero = () => {
    const { t } = useTranslation();
    const heroImage = `${process.env.PUBLIC_URL || ''}/img/hero_image.png`;

    return (
        <HomeHeroContainer
            backgroundImage={heroImage}
            animate={{ opacity: 1 }}
            initial={{ opacity: 0 }}
            transition={{ duration: 2, delay: 1 }}
            exit={{ opacity: 0 }}
        >
            <BodyContainer>
                <Container width={80} leftAlign bottom={2}>
                    <h1>{t('home.title')}</h1>
                </Container>

                <Container leftAlign bottom={6} width={65}>
                    <p>{t('home.description')}</p>
                </Container>

                <Button route="/posts" text={t('home.viewPosts')} right />
            </BodyContainer>
        </HomeHeroContainer>
    );
};

export default HomeHero;
